
export const fetchModulesRoutes = routeFiles => {
  const routes = routeFiles.keys().map(key => {
    const path = key.replace('./', '');
    const entries = path.split('/');
    const module = entries.shift();

    return routeFiles(`./${module}/routes.js`).default;
  });

  return routes;
};

/**
 * Open a new window with pdf
 */
export function openPdf(response, type = 'application/pdf') {
  const file = new Blob([response], { type });
  const url = URL.createObjectURL(file);
  const popUp = window.open(url, '_blank');
  if (!popUp || typeof popUp === 'undefined') {
    // Fallback download when popups are blocked
    const link = document.createElement('a');
    link.href = url;
    link.download = `document.${type.split('/')[1] || 'pdf'}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } else {
    popUp.focus();
  }
}

/**
 * Return a object with error
 * @return object
 */
export function catchPdf(response) {
  const bytes = response instanceof ArrayBuffer
    ? new Uint8Array(response)
    : new Uint8Array(response.buffer || response);
  const decodedString = typeof TextDecoder !== 'undefined'
    ? new TextDecoder('utf-8').decode(bytes)
    : String.fromCharCode.apply(null, bytes);
  const obj = JSON.parse(decodedString);
  return obj.message;
}
